/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.zem.ZemQuestionType
*/
export var ZemQuestionType;
(function (ZemQuestionType) {
    ZemQuestionType["NOUL"] = "NOUL";
    ZemQuestionType["CHOICE"] = "CHOICE";
    ZemQuestionType["SCORE"] = "SCORE";
})(ZemQuestionType || (ZemQuestionType = {}));
//# sourceMappingURL=ZemQuestionType.js.map